/**
 * Причина отказа, понятная пользователю.
 *
 * Живёт отдельным файлом, потому что её показывают оба состояния экрана
 * аккаунта — форма и карточка вошедшего, — а копия текста ошибки в двух
 * местах расходится молча.
 */

import type { Translate } from '@type2x/i18n';
import type { RegistrationProblem } from '@type2x/feature-accounts';

export interface AccountProblemProps {
  readonly t: Translate;
  readonly problem: RegistrationProblem;
}

export function AccountProblem({ t, problem }: AccountProblemProps): React.JSX.Element {
  return (
    <p role="alert" className="t2x-error">
      {t(`account.error.${problem}`)}
    </p>
  );
}
